// extracted by mini-css-extract-plugin
export default {"ans":"Answer_ans__rfu4K","keyAns":"Answer_keyAns__rzGqz","nextButton":"Answer_nextButton__QpKMt"};